var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ie-manage" },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleExport } },
              [
                _c("bi-label", {
                  attrs: { zh: "导出", pt: "Exportar", inline: "" },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: {
                  size: "small",
                  loading: _vm.checking,
                  disabled: _vm.checking,
                },
                on: { click: _vm.handleAllCheck },
              },
              [
                _c("bi-label", {
                  attrs: { zh: "全部检查", pt: "Verificar Tudo", inline: "" },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.openAdd },
              },
              [
                _vm._v(" + "),
                _c("bi-label", {
                  attrs: { zh: "新增 IE", pt: "Nova IE", inline: "" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.searchParam,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "kw-search" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.searchParam.params.kwType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchParam.params,
                                        "kwType",
                                        $$v
                                      )
                                    },
                                    expression: "searchParam.params.kwType",
                                  },
                                },
                                _vm._l(_vm.kwTypeOptions, function (o) {
                                  return _c("el-option", {
                                    key: o.value,
                                    attrs: {
                                      label:
                                        o.label +
                                        (o.labelPt ? " / " + o.labelPt : ""),
                                      value: o.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 4, maxRows: 4 },
                              placeholder: _vm.$t(
                                "GlobalSetObj.CanBeEnteredMultiple2000"
                              ),
                            },
                            model: {
                              value: _vm.searchParam.params.kw,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchParam.params, "kw", $$v)
                              },
                              expression: "searchParam.params.kw",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "UF", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                "collapse-tags": "",
                                clearable: "",
                                filterable: "",
                                placeholder: "全部 / Todos",
                              },
                              model: {
                                value: _vm.searchParam.params.uf,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchParam.params, "uf", $$v)
                                },
                                expression: "searchParam.params.uf",
                              },
                            },
                            _vm._l(_vm.ufOptions, function (uf) {
                              return _c("el-option", {
                                key: uf.id,
                                attrs: { label: uf.label, value: uf.label },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "税务状态",
                                  pt: "Status Fiscal",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "全部 / Todos",
                              },
                              model: {
                                value: _vm.searchParam.params.taxStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "taxStatus",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.taxStatus",
                              },
                            },
                            _vm._l(_vm.taxOptions, function (o) {
                              return _c("el-option", {
                                key: o.value,
                                attrs: {
                                  label: o.label + " / " + o.labelPt,
                                  value: o.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "系统配置",
                                  pt: "Config. Sistema",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "全部 / Todos",
                              },
                              model: {
                                value: _vm.searchParam.params.sysStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "sysStatus",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.sysStatus",
                              },
                            },
                            _vm._l(_vm.sysOptions, function (o) {
                              return _c("el-option", {
                                key: o.value,
                                attrs: {
                                  label: o.label + " / " + o.labelPt,
                                  value: o.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "启用监控",
                                  pt: "Ativar Monitoramento",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "全部 / Todos",
                              },
                              model: {
                                value: _vm.searchParam.params.enable,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "enable",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.enable",
                              },
                            },
                            _vm._l(_vm.enableOptions, function (o) {
                              return _c("el-option", {
                                key: o.value,
                                attrs: {
                                  label: o.label + " / " + o.labelPt,
                                  value: o.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "filter-btns" },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "ph-label" }),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.applyFilter },
                            },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "查询",
                                  pt: "Consultar",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.resetFilter },
                            },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "重置",
                                  pt: "Redefinir",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.pagedRows,
                border: "",
                size: "mini",
                "row-key": "id",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "44" },
              }),
              _c(
                "el-table-column",
                {
                  attrs: { width: "60" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_c("strong", [_vm._v(_vm._s(row.uf))])]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "UF" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "170", "class-name": "cell-num" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.fmtCnpj(row.cnpj)))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "CNPJ" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "160", "class-name": "cell-num" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(row.ie))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "IE" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "200", "show-overflow-tooltip": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(row.companyName))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "公司名称", pt: "Razão Social" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "110" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(row.city))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "城市", pt: "Cidade" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          !row.validade
                            ? _c("span", { staticClass: "vd-empty" }, [
                                _vm._v(" 未录入"),
                                _c("span", { staticClass: "vd-pt" }, [
                                  _vm._v("/ Não Registrado"),
                                ]),
                              ])
                            : _c("span", { class: _vm.validadeCls(row) }, [
                                _vm._v(" " + _vm._s(row.validade) + " "),
                                _c("span", { staticClass: "vd-days" }, [
                                  _vm._v("· " + _vm._s(_vm.validadeText(row))),
                                ]),
                                _c("span", { staticClass: "vd-pt" }, [
                                  _vm._v(_vm._s(_vm.validadeTextPt(row))),
                                ]),
                              ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "有效期限", pt: "Validade" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tag",
                              class: _vm.taxTagCls(row.taxStatus),
                            },
                            [
                              _c("span", { staticClass: "dot" }),
                              _vm._v(_vm._s(_vm.taxText(row.taxStatus)) + " "),
                              _c("span", { staticClass: "tag-pt" }, [
                                _vm._v(
                                  "/ " + _vm._s(_vm.taxTextPt(row.taxStatus))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "税务状态", pt: "Status Fiscal" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            { staticClass: "sys-cell" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "tag",
                                  class:
                                    row.sysStatus === 1
                                      ? "tag-info"
                                      : "tag-err",
                                },
                                [
                                  _c("span", { staticClass: "dot" }),
                                  _vm._v(
                                    _vm._s(_vm.sysText(row.sysStatus)) + " "
                                  ),
                                  _c("span", { staticClass: "tag-pt" }, [
                                    _vm._v(
                                      "/ " +
                                        _vm._s(_vm.sysTextPt(row.sysStatus))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openSysop(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(" 检索代码配置"),
                                  _c("span", { staticClass: "sys-pt" }, [
                                    _vm._v("/ Buscar Config."),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: {
                          zh: "系统配置 · 操作",
                          pt: "Config. Sistema · Ação",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "150", "class-name": "cell-num" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.fmtStamp(row.lastCheckTime)))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "最后检查时间", pt: "Última Verificação" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "72", align: "center", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("toggle-switch", {
                            attrs: {
                              value: row.enable === 1,
                              "on-text": "启用 / Ativado",
                              "off-text": "停用 / Desativado",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleToggleEnable(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "启用", pt: "Ativação" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "230", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "act-group" }, [
                            _c(
                              "a",
                              {
                                staticClass: "act-view",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView(row)
                                  },
                                },
                              },
                              [
                                _vm._v(" 查看"),
                                _c("span", { staticClass: "act-pt" }, [
                                  _vm._v("/ Ver"),
                                ]),
                              ]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "act-view",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleQuery(row)
                                  },
                                },
                              },
                              [
                                _vm._v(" 查询"),
                                _c("span", { staticClass: "act-pt" }, [
                                  _vm._v("/ Consultar"),
                                ]),
                              ]
                            ),
                            _c(
                              "a",
                              {
                                class:
                                  row.enable === 1
                                    ? "act-edit disabled"
                                    : "act-edit",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(row)
                                  },
                                },
                              },
                              [
                                _vm._v(" 编辑"),
                                _c("span", { staticClass: "act-pt" }, [
                                  _vm._v("/ Editar"),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "操作", pt: "Ações" } })],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c(
                "el-pagination",
                {
                  staticClass: "ie-pagination",
                  attrs: {
                    "current-page": _vm.searchParam.pageNumber,
                    "page-size": _vm.searchParam.pageSize,
                    "page-sizes": [10, 20, 50],
                    total: _vm.total,
                    layout: "slot, sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageNumber", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageNumber", $event)
                    },
                    "update:pageSize": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageSize", $event)
                    },
                    "update:page-size": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageSize", $event)
                    },
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                },
                [
                  _c("span", { staticClass: "pb-total" }, [
                    _vm._v(" 共 " + _vm._s(_vm.total) + " 条"),
                    _c("span", { staticClass: "pb-pt" }, [
                      _vm._v("/ Total: " + _vm._s(_vm.total) + " registros"),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ie-form-dialog", {
        attrs: {
          visible: _vm.formVisible,
          mode: _vm.formMode,
          row: _vm.currentRow,
          "state-list": _vm.stateList,
        },
        on: {
          "update:visible": function ($event) {
            _vm.formVisible = $event
          },
          save: _vm.handleSave,
        },
      }),
      _c("sysop-dialog", {
        attrs: { visible: _vm.sysopVisible, row: _vm.currentRow },
        on: {
          "update:visible": function ($event) {
            _vm.sysopVisible = $event
          },
          updated: _vm.handleSysopUpdated,
        },
      }),
      _c("confirm-dialog", {
        attrs: {
          visible: _vm.confirmVisible,
          title: _vm.confirmOpts.title,
          "title-pt": _vm.confirmOpts.titlePt,
          subtitle: _vm.confirmOpts.subtitle,
          desc: _vm.confirmOpts.desc,
          "desc-pt": _vm.confirmOpts.descPt,
          "ok-text": _vm.confirmOpts.okText,
          "ok-text-pt": _vm.confirmOpts.okTextPt,
          kind: _vm.confirmOpts.kind,
        },
        on: {
          "update:visible": function ($event) {
            _vm.confirmVisible = $event
          },
          confirm: _vm.confirmOpts.onOk,
        },
      }),
      _c("uf-detail-drawer", {
        attrs: {
          id: _vm.detailId,
          visible: _vm.detailVisible,
          uf: _vm.detailUf,
          detail: _vm.detailRow,
          "change-log": _vm.detailChangeLog,
        },
        on: {
          "update:visible": function ($event) {
            _vm.detailVisible = $event
          },
          check: _vm.handleQueryByUf,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", { staticStyle: { "margin-top": "0" } }, [
        _vm._v(" IE 信息管理 "),
        _c("span", { staticClass: "h2-pt" }, [_vm._v("Gestão de IE")]),
      ]),
      _c("div", { staticClass: "desc" }, [
        _c("span", [
          _vm._v(
            "维护受监控的开票主体：UF、CNPJ、IE、公司名称、城市、双轨状态"
          ),
        ]),
        _c("span", { staticClass: "desc-pt" }, [
          _vm._v(
            " Gerencie as entidades emissoras monitoradas: UF, CNPJ, IE, razão social, cidade e status das duas trilhas "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }